import { useMemo } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { useClausesForField } from '@atlassian/jira-jql-utils/src/utils/use-clauses-for-field/index.tsx';
import { isOnlyAndOperator } from '@atlassian/jira-jql-utils/src/utils/operator-checking-visitor/index.tsx';
import { useAST } from '../index.tsx';
import { ASSIGNEE, VALID_ASSIGNEE_OPERATORS } from '../../../common/constants.tsx';

/**
 * Determines if the assignee picker should be disabled or enabled depending on JQL/AST complexity
 * The assignee picker should be enabled if:
 * - Only AND operators in compound clauses in JQL
 * - Maximum one assignee clause
 * - Only = or IN operator for the assignee clause
 */
export const useIsAssigneePickerEnabled = () => {
	const ast = useAST();
	const assigneeClauses = useClausesForField(ast, ASSIGNEE);
	const onlyAndOperator = useMemo(() => isOnlyAndOperator(ast), [ast]);
	return (
		onlyAndOperator &&
		assigneeClauses.length <= 1 &&
		assigneeClauses.every(
			(clause) => clause.operator?.value && VALID_ASSIGNEE_OPERATORS.has(clause.operator?.value),
		)
	);
};

export const useIsAssigneePickerEnabledWithFG = functionWithCondition(
	() => fg('list_lovability_improving_filters'),
	useIsAssigneePickerEnabled,
	() => true,
);
